import React, { useState } from 'react';
import Modal from './Modal';

const ReturnReasonModal = ({ isOpen, onClose, onConfirm, ticketInfo }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  // Formatear el ID del asiento para mejor legibilidad
  const formatSeatId = (compositeId) => {
    // Convertir "PB-1-2" a "Planta Baja - Fila 1 - Asiento 2"
    const parts = compositeId.split('-');
    if (parts.length === 3) {
      const section = parts[0] === 'BOX' ? 'Palco' :
                     parts[0] === 'PB' ? 'Planta Baja' : 
                     parts[0] === 'PP' ? 'Primer Piso' : parts[0];
      const row = parts[1];
      const seat = parts[2];
      return `${section} - Fila ${row} - Asiento ${seat}`;
    }
    return compositeId;
  };

  // Obtener texto del estado
  const getStatusText = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return 'Reservado';
      case 'confirmed':
        return 'Confirmada';
      case 'sold':
        return 'Vendida';
      case 'delivered':
        return 'Entregada';
      case 'returned':
        return 'Devuelta';
      case 'cancelled':
        return 'Cancelada';
      case 'blocked':
        return 'Bloqueado';
      default:
        return status || 'N/A';
    }
  };

  // Obtener color del estado
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'sold':
        return 'bg-green-100 text-green-800';
      case 'delivered':
        return 'bg-purple-100 text-purple-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'confirmed':
        return 'bg-blue-100 text-blue-800';
      case 'returned':
        return 'bg-orange-100 text-orange-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      case 'blocked':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!reason.trim()) {
      setError('El motivo de devolución es obligatorio');
      return;
    }

    onConfirm(reason.trim());
    setReason('');
    setError('');
  };

  const handleClose = () => {
    setReason('');
    setError('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Motivo de Devolución">
      <div className="space-y-4">
        {/* Información del ticket */}
        {ticketInfo && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-medium text-blue-800 mb-3">Información del Ticket</h4>
            <div className="space-y-3 text-sm">
              <div>
                <span className="text-blue-600 font-medium">Asiento:</span>
                <span className="ml-2 text-blue-800">
                  {formatSeatId(ticketInfo.compositeId)}
                </span>
              </div>
              <div>
                <span className="text-blue-600 font-medium">Precio:</span>
                <span className="ml-2 text-blue-800 font-medium">
                  ${parseFloat(ticketInfo.price || 0).toLocaleString()}
                </span>
              </div>
              <div>
                <span className="text-blue-600 font-medium">Estado:</span>
                <span className={`ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(ticketInfo.status)}`}>
                  {getStatusText(ticketInfo.status)}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Formulario del motivo */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="returnReason" className="block text-sm font-medium text-gray-700 mb-2">
              Motivo de la devolución *
            </label>
            <textarea
              id="returnReason"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (error) setError('');
              }}
              rows={4}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 ${
                error ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Ingrese el motivo de la devolución..."
              required
            />
            {error && (
              <p className="text-red-600 text-sm mt-1">{error}</p>
            )}
          </div>

          {/* Botones */}
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={!reason.trim()}
              className={`px-4 py-2 rounded-md focus:outline-none focus:ring-2 ${
                !reason.trim() 
                  ? 'bg-gray-400 text-gray-600 cursor-not-allowed' 
                  : 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500'
              }`}
            >
              Confirmar Devolución
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ReturnReasonModal;